/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetOnlineBookingsConfigDocument = gql`
    query GetOnlineBookingsConfig($page: Int, $itemsPerPage: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      name
      bookingQrLink
      category {
        id
        type
        name
      }
      country {
        id
        name
        europeanUnion
      }
      city {
        id
        name
      }
      timeZone {
        id
        name
      }
      messageLanguage {
        id
        name
        isoCode
      }
      currency {
        id
      }
      address
      branchesPaginated(page: $page, itemsPerPage: $itemsPerPage, isDeleted: false) {
        totalCount
        currentPage
        itemsPerPage
        pageCount
        branches {
          id
          name
          workSchedule
          type {
            id
            name
            slug
          }
          bookingQrLink
          city {
            id
            name
          }
          address
          onlineRegistration
          country {
            id
            name
            localeCode
            isoCode
            isInEuropeanUnion
            continentName
          }
          timeZone
          currencyCode
          deleted
          removedOfTariff
          category {
            name
            id
            type
          }
          phones {
            id
            phone
            branch {
              id
              name
              bookingQrLink
              name
              timeZone
              country {
                id
                name
                isoCode
                continentName
                isInEuropeanUnion
                localeCode
              }
              address
              deleted
            }
          }
        }
        isCanCreateNewBranch
      }
      meBookingModuleConfig {
        id
        onlineBooking
        confirmationCall
        allowedDuration {
          name
          value
        }
      }
      deleted
      phone
    }
  }
}
    `;

/**
 * __useGetOnlineBookingsConfigQuery__
 *
 * To run a query within a React component, call `useGetOnlineBookingsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlineBookingsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnlineBookingsConfigQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetOnlineBookingsConfigQuery(baseOptions: Apollo.QueryHookOptions<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables> & ({ variables: GetOnlineBookingsConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables>(GetOnlineBookingsConfigDocument, options);
      }
export function useGetOnlineBookingsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables>(GetOnlineBookingsConfigDocument, options);
        }
export function useGetOnlineBookingsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables>(GetOnlineBookingsConfigDocument, options);
        }
export type GetOnlineBookingsConfigQueryHookResult = ReturnType<typeof useGetOnlineBookingsConfigQuery>;
export type GetOnlineBookingsConfigLazyQueryHookResult = ReturnType<typeof useGetOnlineBookingsConfigLazyQuery>;
export type GetOnlineBookingsConfigSuspenseQueryHookResult = ReturnType<typeof useGetOnlineBookingsConfigSuspenseQuery>;
export type GetOnlineBookingsConfigQueryResult = Apollo.QueryResult<GetOnlineBookingsConfigQuery, GetOnlineBookingsConfigQueryVariables>;
export const GetBookingAllowedDurationsDocument = gql`
    query GetBookingAllowedDurations {
  bookingAllowedDurations {
    name
    value
  }
}
    `;

/**
 * __useGetBookingAllowedDurationsQuery__
 *
 * To run a query within a React component, call `useGetBookingAllowedDurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAllowedDurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAllowedDurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingAllowedDurationsQuery(baseOptions?: Apollo.QueryHookOptions<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>(GetBookingAllowedDurationsDocument, options);
      }
export function useGetBookingAllowedDurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>(GetBookingAllowedDurationsDocument, options);
        }
export function useGetBookingAllowedDurationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>(GetBookingAllowedDurationsDocument, options);
        }
export type GetBookingAllowedDurationsQueryHookResult = ReturnType<typeof useGetBookingAllowedDurationsQuery>;
export type GetBookingAllowedDurationsLazyQueryHookResult = ReturnType<typeof useGetBookingAllowedDurationsLazyQuery>;
export type GetBookingAllowedDurationsSuspenseQueryHookResult = ReturnType<typeof useGetBookingAllowedDurationsSuspenseQuery>;
export type GetBookingAllowedDurationsQueryResult = Apollo.QueryResult<GetBookingAllowedDurationsQuery, GetBookingAllowedDurationsQueryVariables>;
export const UpdateMeBookingModuleConfigDocument = gql`
    mutation UpdateMeBookingModuleConfig($id: Int!, $input: CompanyInput!, $branchId: Int!) {
  updateCompany(id: $id, input: $input, branchId: $branchId) {
    meBookingModuleConfig {
      confirmationCall
      onlineBooking
      id
    }
    address
    deleted
    id
    name
    paidFeaturesPaginated {
      totalCount
    }
    phone
  }
}
    `;
export type UpdateMeBookingModuleConfigMutationFn = Apollo.MutationFunction<UpdateMeBookingModuleConfigMutation, UpdateMeBookingModuleConfigMutationVariables>;

/**
 * __useUpdateMeBookingModuleConfigMutation__
 *
 * To run a mutation, you first call `useUpdateMeBookingModuleConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeBookingModuleConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeBookingModuleConfigMutation, { data, loading, error }] = useUpdateMeBookingModuleConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateMeBookingModuleConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeBookingModuleConfigMutation, UpdateMeBookingModuleConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeBookingModuleConfigMutation, UpdateMeBookingModuleConfigMutationVariables>(UpdateMeBookingModuleConfigDocument, options);
      }
export type UpdateMeBookingModuleConfigMutationHookResult = ReturnType<typeof useUpdateMeBookingModuleConfigMutation>;
export type UpdateMeBookingModuleConfigMutationResult = Apollo.MutationResult<UpdateMeBookingModuleConfigMutation>;
export type UpdateMeBookingModuleConfigMutationOptions = Apollo.BaseMutationOptions<UpdateMeBookingModuleConfigMutation, UpdateMeBookingModuleConfigMutationVariables>;
export const UpdateBranchForOnlineBookingDocument = gql`
    mutation UpdateBranchForOnlineBooking($id: Int!, $input: BranchInput!) {
  updateBranch(id: $id, input: $input) {
    id
    name
    address
    onlineRegistration
    bookingQrLink
    deleted
  }
}
    `;
export type UpdateBranchForOnlineBookingMutationFn = Apollo.MutationFunction<UpdateBranchForOnlineBookingMutation, UpdateBranchForOnlineBookingMutationVariables>;

/**
 * __useUpdateBranchForOnlineBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBranchForOnlineBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBranchForOnlineBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBranchForOnlineBookingMutation, { data, loading, error }] = useUpdateBranchForOnlineBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBranchForOnlineBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBranchForOnlineBookingMutation, UpdateBranchForOnlineBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBranchForOnlineBookingMutation, UpdateBranchForOnlineBookingMutationVariables>(UpdateBranchForOnlineBookingDocument, options);
      }
export type UpdateBranchForOnlineBookingMutationHookResult = ReturnType<typeof useUpdateBranchForOnlineBookingMutation>;
export type UpdateBranchForOnlineBookingMutationResult = Apollo.MutationResult<UpdateBranchForOnlineBookingMutation>;
export type UpdateBranchForOnlineBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBranchForOnlineBookingMutation, UpdateBranchForOnlineBookingMutationVariables>;
export const UpdateCompanyOnlineBookingSettingsDocument = gql`
    mutation UpdateCompanyOnlineBookingSettings($companyId: Int!, $branchId: Int!, $input: OnlineBookingSettings!) {
  updateCompanyOnlineBookingSettings(
    companyId: $companyId
    branchId: $branchId
    input: $input
  )
}
    `;
export type UpdateCompanyOnlineBookingSettingsMutationFn = Apollo.MutationFunction<UpdateCompanyOnlineBookingSettingsMutation, UpdateCompanyOnlineBookingSettingsMutationVariables>;

/**
 * __useUpdateCompanyOnlineBookingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyOnlineBookingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyOnlineBookingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyOnlineBookingSettingsMutation, { data, loading, error }] = useUpdateCompanyOnlineBookingSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyOnlineBookingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyOnlineBookingSettingsMutation, UpdateCompanyOnlineBookingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyOnlineBookingSettingsMutation, UpdateCompanyOnlineBookingSettingsMutationVariables>(UpdateCompanyOnlineBookingSettingsDocument, options);
      }
export type UpdateCompanyOnlineBookingSettingsMutationHookResult = ReturnType<typeof useUpdateCompanyOnlineBookingSettingsMutation>;
export type UpdateCompanyOnlineBookingSettingsMutationResult = Apollo.MutationResult<UpdateCompanyOnlineBookingSettingsMutation>;
export type UpdateCompanyOnlineBookingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyOnlineBookingSettingsMutation, UpdateCompanyOnlineBookingSettingsMutationVariables>;
export const UpdateBranchOnlineBookingSettingsDocument = gql`
    mutation UpdateBranchOnlineBookingSettings($companyId: Int!, $branchId: Int!, $input: OnlineBookingSettings!) {
  updateBranchOnlineBookingSettings(
    companyId: $companyId
    branchId: $branchId
    input: $input
  )
}
    `;
export type UpdateBranchOnlineBookingSettingsMutationFn = Apollo.MutationFunction<UpdateBranchOnlineBookingSettingsMutation, UpdateBranchOnlineBookingSettingsMutationVariables>;

/**
 * __useUpdateBranchOnlineBookingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateBranchOnlineBookingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBranchOnlineBookingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBranchOnlineBookingSettingsMutation, { data, loading, error }] = useUpdateBranchOnlineBookingSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBranchOnlineBookingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBranchOnlineBookingSettingsMutation, UpdateBranchOnlineBookingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBranchOnlineBookingSettingsMutation, UpdateBranchOnlineBookingSettingsMutationVariables>(UpdateBranchOnlineBookingSettingsDocument, options);
      }
export type UpdateBranchOnlineBookingSettingsMutationHookResult = ReturnType<typeof useUpdateBranchOnlineBookingSettingsMutation>;
export type UpdateBranchOnlineBookingSettingsMutationResult = Apollo.MutationResult<UpdateBranchOnlineBookingSettingsMutation>;
export type UpdateBranchOnlineBookingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateBranchOnlineBookingSettingsMutation, UpdateBranchOnlineBookingSettingsMutationVariables>;
export type GetOnlineBookingsConfigQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetOnlineBookingsConfigQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, name: string, bookingQrLink: string, address: string, deleted: boolean, phone: string, category?: { __typename?: 'CompanyTypeProxy', id: number, type: string, name: string } | null, country?: { __typename?: 'CountryProxy', id: number, name: string, europeanUnion: boolean } | null, city?: { __typename?: 'CityProxy', id: number, name: string } | null, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null, messageLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null, currency?: { __typename?: 'CurrencyProxy', id: number } | null, branchesPaginated?: { __typename?: 'BranchPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, isCanCreateNewBranch: boolean, branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string, workSchedule?: string | null, bookingQrLink: string, address: string, onlineRegistration: boolean, timeZone: string, currencyCode: string, deleted: boolean, removedOfTariff: boolean, type?: { __typename?: 'BranchTypeProxy', id: number, name: string, slug?: string | null } | null, city?: { __typename?: 'CityProxy', id: number, name: string } | null, country: { __typename?: 'Country', id: string, name: string, localeCode: string, isoCode: string, isInEuropeanUnion: boolean, continentName: string }, category?: { __typename?: 'CompanyTypeProxy', name: string, id: number, type: string } | null, phones?: Array<{ __typename?: 'BranchPhoneProxy', id: number, phone: string, branch: { __typename?: 'BranchProxy', id: number, name: string, bookingQrLink: string, timeZone: string, address: string, deleted: boolean, country: { __typename?: 'Country', id: string, name: string, isoCode: string, continentName: string, isInEuropeanUnion: boolean, localeCode: string } } }> | null }> | null } | null, meBookingModuleConfig?: { __typename?: 'BookingModuleConfigProxy', id: number, onlineBooking: boolean, confirmationCall: boolean, allowedDuration?: { __typename?: 'BookingAllowedDurationProxy', name: string, value: string } | null } | null } | null } | null };

export type GetBookingAllowedDurationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBookingAllowedDurationsQuery = { __typename?: 'Query', bookingAllowedDurations: Array<{ __typename?: 'BookingAllowedDurationProxy', name: string, value: string } | null> };

export type UpdateMeBookingModuleConfigMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.CompanyInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateMeBookingModuleConfigMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyProxy', address: string, deleted: boolean, id: number, name: string, phone: string, meBookingModuleConfig?: { __typename?: 'BookingModuleConfigProxy', confirmationCall: boolean, onlineBooking: boolean, id: number } | null, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', totalCount?: number | null } } };

export type UpdateBranchForOnlineBookingMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.BranchInput;
}>;


export type UpdateBranchForOnlineBookingMutation = { __typename?: 'Mutation', updateBranch: { __typename?: 'BranchProxy', id: number, name: string, address: string, onlineRegistration: boolean, bookingQrLink: string, deleted: boolean } };

export type UpdateCompanyOnlineBookingSettingsMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  input: Types.OnlineBookingSettings;
}>;


export type UpdateCompanyOnlineBookingSettingsMutation = { __typename?: 'Mutation', updateCompanyOnlineBookingSettings: boolean };

export type UpdateBranchOnlineBookingSettingsMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  input: Types.OnlineBookingSettings;
}>;


export type UpdateBranchOnlineBookingSettingsMutation = { __typename?: 'Mutation', updateBranchOnlineBookingSettings: boolean };
